<template>
  <div
    class="spinner"
    :style="{
      borderLeftColor: '#FFDD00',
    }"
  ></div>
</template>
